var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("wizard", {
        attrs: {
          "wizard-data": _vm.wizardData,
          "wizard-config": _vm.wizardConfig,
          loading: _vm.isWizarLoading
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }